module.exports = __webpack_public_path__ + "static/media/overline.1862c2bb.svg";